export default "__VITE_ASSET__B97GnrkO__"